import { z } from 'zod'

export const TermsVersion = z.object({
  id: z.string(),
  published_at: z.string().datetime({ offset: true }),
  effective_at: z.string().datetime({ offset: true }),
  material: z.boolean()
})

export type TermsVersion = z.infer<typeof TermsVersion>

/** Published versions only, oldest first; the list order is the version order, never the id. */
export const TermsConfig = z.object({
  current_version: z.string(),
  published_at: z.string().datetime({ offset: true }),
  versions: z.array(TermsVersion)
})

export type TermsConfig = z.infer<typeof TermsConfig>
